import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["recommendedCheckbox", "template", "container"];

  connect() {
    Array.from(this.containerTarget.children).slice(0, -1).forEach((child, index) => {
      // slice(0, -1) to skip the last child which is the template
      child.innerHTML = child.innerHTML.replace(/ABO_NR_X/g, this.newAboName(index + 1))
    });
  }

  newAboName(index = 1) {
    return "Abo Nr. " + index
  }

  handleCheckboxChange(event) {
    const checkbox = event.target;

    // Uncheck all other checkboxes
    this.recommendedCheckboxTargets.forEach((otherCheckbox) => {
      if (otherCheckbox !== checkbox) {
        otherCheckbox.checked = false;
        checkbox.checked = true; // Ensure the current checkbox remains checked
      }
    });
  }

  add(event) {
    event.preventDefault();
    const timeStamp = new Date().getTime()
    const childIndex = this.containerTarget.children.length;
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, timeStamp).replace(/ABO_NR_X/g, this.newAboName(childIndex));
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  async handleDeleteClick(event) {
    event.preventDefault();
    const formSection = event.target.closest(".form__section");
    const idField = formSection.querySelector("input[name*='id']")
    if (!idField.value) {
      formSection.remove();
      return;
    }

    const communitySlug = formSection.dataset.communitySlug;

    if (!communitySlug) {
      alert("Fehler: Community-Slug nicht gefunden.");
      return;
    }

    try {
      const response = await fetch(`/communities/${communitySlug}/subscription_types/${idField.value}`, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").getAttribute("content"),
          "Accept": "application/json"
        }
      });

      if (response.ok) {
        formSection.remove();
      }
      else {
        const data = await response.json();
        const errorMessage = data.errors ? data.errors.join(", ") : "Fehler beim Löschen";
        alert(errorMessage);

      }
    } catch (error) {
      alert("Fehler beim Löschen des Abos");
    }
  }
}
